import { useState } from "react";
import { StyledMenu } from "./styledMenus";
import { Box, Button, List } from "@mui/material";
import { useAuth } from "../provider/auth_provider";
import { NavItem } from "./chatbot_navbar";
import { useLocation } from "react-router-dom";
import {
  FaceRetouchingNaturalOutlined,
  DonutSmallOutlined,
  DocumentScannerOutlined,
  HelpCenterOutlined,
} from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import CaOptionsMenu from "./CaOptionsMenu";
import PolicyIcon from "@mui/icons-material/Policy";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import GavelIcon from "@mui/icons-material/Gavel";

type PageChangeDropdownProps = {
  tool: any;
};

export default function PageChangeDropdown({ tool }: PageChangeDropdownProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showAdditonalMenu, setShowAdditonalMenu] = useState(false);
  const open = Boolean(anchorEl);
  const { userDetails } = useAuth();
  const { pathname, search } = useLocation();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        size="medium"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        startIcon={<BuildOutlinedIcon />}
        sx={{
          color: "#444746",
          fontSize: "1rem !important",
          padding: "0.5rem 1.25rem",
          cursor: "pointer",
          marginLeft: "0.4rem",
        }}
      >
        {tool}
      </Button>

      {showAdditonalMenu && (
        <CaOptionsMenu
          onClose={() => {
            setShowAdditonalMenu(false);
            handleClose();
          }}
          open={showAdditonalMenu}
        />
      )}
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{ "aria-labelledby": "demo-customized-button" }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <List>
          {userDetails?.scopes?.includes("people") && (
            <NavItem
              href="/people"
              label="Chat @ People"
              pathname={pathname}
              icon={<FaceRetouchingNaturalOutlined />}
              onClick={handleClose}
            />
          )}
          {/* {userDetails?.scopes?.includes("company") && (
            <NavItem
              href="/company"
              label="Chat @ Company"
              pathname={pathname}
              icon={<AutoGraphOutlined />}
              onClick={(e: any) => {
                e.stopPropagation();
                setShowAdditonalMenu(true);
              }}
              endIcon={<ChevronRightOutlinedIcon />}
            />
          )} */}
          {userDetails?.scopes?.includes("product") && (
            <NavItem
              href="/product"
              label="Chat @ Product"
              pathname={pathname}
              icon={<DonutSmallOutlined />}
              onClick={handleClose}
            />
          )}
          {userDetails?.scopes?.includes("help") && (
            <NavItem
              href="/help"
              label="Chat @ Help"
              pathname={pathname}
              icon={<HelpCenterOutlined />}
              onClick={handleClose}
            />
          )}
          {userDetails?.scopes?.includes("document") && (
            <NavItem
              href="/document"
              label="Chat @ Document"
              pathname={pathname + search}
              icon={<DocumentScannerOutlined />}
              onClick={handleClose}
            />
          )}
          {userDetails?.scopes?.includes("legal") && (
            <NavItem
              href="/legal"
              label="Chat @ Legal AI - Petition"
              pathname={pathname + search}
              icon={<GavelIcon />}
              onClick={handleClose}
            />
          )}
          {userDetails?.scopes?.includes("qc") && (
            <NavItem
              href="/qc"
              label="Chat @ QC"
              pathname={pathname + search}
              icon={<CheckCircleOutlineIcon />}
              onClick={handleClose}
            />
          )}
          {userDetails?.scopes?.includes("kyp") && (
            <NavItem
              href="/kyp"
              label="Chat @ KYP"
              pathname={pathname + search}
              icon={<PolicyIcon />}
              onClick={handleClose}
            />
          )}
          {true && (
            <NavItem
              href="/wc-claims"
              label="Chat @ WC Claims"
              pathname={pathname}
              icon={<DocumentScannerOutlined />}
              onClick={handleClose}
            />
          )}
        </List>
      </StyledMenu>
    </Box>
  );
}
